import React, { FC, useState, ReactNode, CSSProperties, useCallback, useEffect } from "react";
import styles from "./Tab.module.css";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { TTabbedContentProps } from "types/TabbedContent";
import { getAssetPath } from "utils";
import classNames from "classnames";
import he from "he";
import $ from "jquery";
import { each } from "lodash";
import { TextEditor } from "components/molecules";

/* Types */
interface TabPanelProps {
    children?: ReactNode;
    index: number;
    activeTab: number;
}

/* Generate Node Meta Data */
function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const TabbedContent: FC<TTabbedContentProps> = ({
    tabTextColor = "white",
    DesktopImage,
    MobileImage,
    BackgroundColour = '#666666',
    TabLinkPool,
    TextEditor: _TextEditor
}) => {
    /* Component State */
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
            document.querySelectorAll('.MuiTabs-scroller .MuiButtonBase-root').forEach(function(node, i) {
                const width = node.clientWidth;
                const index = i;

                const move = function(){
                    const indicator = document.querySelector('.MuiTabs-indicator') as any;
                    indicator.style.left = `${width * index}px`;
                }
                const reset = function(){
                    const indicator = document.querySelector('.MuiTabs-indicator') as any;
                    indicator.style.left = `${width * activeTab}px`;
                }

                node.removeEventListener('mouseover', move)
                node.removeEventListener('mouseleave', reset)

                node.addEventListener('mouseover', move)
                node.addEventListener('mouseleave', reset)
        })
    }, [activeTab])

    /* Tab Panel Component */
    const TabPanel = useCallback((props: TabPanelProps) => {
        const { children, activeTab, index, ...other } = props;
        return (
            <div
                role="tabpanel"
                hidden={activeTab !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {activeTab === index && (
                    <Box sx={{ p: 3 }}>
                        {children}
                    </Box>
                )}
            </div>
        );
    }, []);

    /* Event Listeners */
    const handleChange = (event: React.SyntheticEvent, newactiveTab: number) => {
        setActiveTab(newactiveTab);
    };

    return (
        <div className={styles.wrapper}
            style={{ '--tabTextColor': tabTextColor } as CSSProperties}
        >
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    {/* Tabs Forword*/}
                    <div className={styles.tabForewordWrapper}>
                    <TextEditor className={styles.tabForeword}
                        data={_TextEditor}
                    />
                    </div>
                    {/* Tabs */}
                    <Tabs
                        value={activeTab}
                        onChange={handleChange}
                        aria-label="basic tabs example">
                        {TabLinkPool?.length && TabLinkPool.map((v, i) => {
                            const title = he.decode(v?.TabTitle);
                            return <Tab key={title + i + '-Tab'} label={title || `TAB-ITEM-${i}`} {...a11yProps(i)} />
                        }

                        )}
                    </Tabs>
                </Box>
                {/* Tab Panels */}
                {TabLinkPool?.length && TabLinkPool.map((v, i) => {
                    const title = he.decode(v.TabTitle);
                    const heading = he.decode(v.ContentHeading);
                    const iconSrc = he.decode(v.Icon?.Src);
                    const iconAlt = he.decode(v.Icon?.Alt);
                    return (
                        <TabPanel key={title + i + '-TabPanel'} activeTab={activeTab} index={i}>
                            <div
                                className={styles.tabPanelContentWrapper}
                                key={'tabbed-content-desktop-' + i}>
                                {/* Tab Panel Content Icon With Text */}
                                <div className={styles.tabPanelContentIconWithText}>
                                    <img src={getAssetPath(iconSrc)} alt={iconAlt} />
                                    <h1>{heading}</h1>
                                    <p className={styles.tabPanelContentSummary} dangerouslySetInnerHTML={{ __html: v.ContentSummary }}></p>
                                </div>
                                {/* Tab Panel Content Wrapper Article */}
                                <TextEditor className={classNames(styles.tabPanelContentWrapperArticle, "tabbed-content")}
                                    data={v.TextEditor}
                                />
                            </div>
                        </TabPanel>
                    )
                })}
            </Box>
        </div>
    )
};